import { axiosInstance } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import type {User} from '@/types/User';

const listUsers = async (velId) : Promise<User[]> => {
  const { data } = await axiosInstance.get(
    `/api/abo/vel/${velId}/user`
  );
  return data;
};

export const useUserList = ({velId}) => {
  return useQuery({
    queryKey: ['vel', velId, 'users'],
    queryFn: () => listUsers(velId),
    enabled: !!velId
  })
};
